import React, { Component } from "react";
import { Col, Row } from "reactstrap";
import HomeNews from "../features/News/HomeNews";
import Schedule from "../components/Home/Schedule";
import "../styles/pages/Home.css";
import { getHomeNews } from "../features/News/data";
import Spinner from "../containers/Spinner";
import Kryefaqe from "../features/Kryefaqe/index";

class Main extends Component {
  state = {};
  componentWillMount = () => {
    getHomeNews().then(response => {
      this.setState({ finished: true, lajmet: response });
    });
  };
  render() {
    if (!this.state.finished) {
      return <Spinner />;
    }
    return (
      <div className="news-container">
        <Row>
          <Col sm="12" lg="6" className="rendi-dites">
            <Schedule />
          </Col>
          <Col sm="12" lg="6">
            <HomeNews data={this.state.lajmet} className="home-news-small" />
          </Col>
        </Row>

        <Kryefaqe />
      </div>
    );
  }
}

export default Main;
